import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

import "../option-menu.css";
import { items } from "../optionMenu";
import { useState } from "react";
const OptionMenu = () => {
  const { optionTitle } = items[0];

  const [selected, setSelected] = useState(optionTitle);
  const handleSelect = (e) => {
    setSelected(e.target.value);
  };
  return (
    <>
      {items.map((item, index) => {
        const { labelDesc, optionItems } = item;
        return (
          <div className="col-md-6 mb-3" key={index}>
            <label htmlFor="">{labelDesc}</label>
            <DropdownButton
              id="dropdown-basic-button"
              title={selected}
              onSelect={handleSelect}
           
            >
              {optionItems.map((item, index) => {
                const { title, color } = item;

                return (
                  <Dropdown.Item href="#/action-1" key={index} value={selected}>
                    <svg
                      width="20"
                      height="17"
                      viewBox="0 0 20 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2"
                    >
                      <path
                        d="M9.80964 14.4065C9.80964 15.3234 9.06648 16.0667 8.14952 16.0667C7.23267 16.0667 6.48941 15.3234 6.48941 14.4065C6.48941 13.4897 7.23267 12.7464 8.14952 12.7464C9.06652 12.7464 9.80964 13.4897 9.80964 14.4065Z"
                        fill={color}
                      />
                      <path
                        d="M16.3337 14.4066C16.3337 15.3235 15.5905 16.0668 14.6736 16.0668C13.7568 16.0668 13.0135 15.3235 13.0135 14.4066C13.0135 13.4898 13.7568 12.7465 14.6736 12.7465C15.5905 12.7465 16.3337 13.4898 16.3337 14.4066Z"
                        fill={color}
                      />
                      <path
                        d="M18.9788 2.94025C18.8051 2.70865 18.5349 2.59285 18.2452 2.59285H5.71717L5.27322 0.797682C5.17667 0.372864 4.79063 0.0833435 4.36595 0.0833435H1.75988C1.23865 0.0833435 0.833344 0.508024 0.833344 1.00988C0.833344 1.51175 1.25802 1.93643 1.75988 1.93643L3.63234 1.93656L5.94874 11.183C6.04529 11.6077 6.43133 11.8972 6.85602 11.8972H16.4306C16.8553 11.8972 17.2414 11.6077 17.3379 11.183L19.1331 3.7318C19.2104 3.46156 19.1525 3.17206 18.9786 2.94032L18.9788 2.94025ZM13.6317 9.31046L12.9368 9.81232C12.821 9.90886 12.6473 9.87022 12.5507 9.75442L11.4311 8.21009L10.9678 8.78923C10.7747 9.02084 10.3887 8.92443 10.3308 8.63479L9.61658 5.06361C9.55867 4.75472 9.88682 4.52311 10.1571 4.67757L13.3229 6.47274C13.5931 6.62719 13.5545 7.01325 13.2842 7.12903L12.5893 7.41853L13.7089 8.96286C13.7862 9.05941 13.7476 9.23324 13.6318 9.31039L13.6317 9.31046Z"
                        fill={color}
                      />
                    </svg>
                    {title}
                  </Dropdown.Item>
                );
              })}
            </DropdownButton>
          </div>
        );
      })}
    </>
  );
};

export default OptionMenu;
